<template>
    <div class="view-tree-table">
        <!-- router-title-box start -->
		<div class="router-title-box" >
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">地图配置</div>
			</div>
		</div>
		<!-- router-title-box end -->
		
		<OrgTree :organizations="organizations" :showBoxFlag="showTreeBoxFlag" @toggleBox="toggleTreeBox" @setSelectVal="setSelectVal" @addNode="addNode" @closeSecondModule="closeSecondModule" ref="orgTree"/>
		<OrgModule ref="OrgModule" :nodeData="nodeData" :nodeLevel="nodeLevel" @setSelectVal="setSelectVal" v-show="nodeLevel>-1"/>
    </div>
</template>

<script>
	import OrgTree from '@/components_pages/Organization/OrgTree'
	import OrgModule from '@/components_pages/Organization/OrgModule'
	import ApiOam from "@/request/api-oam";
	import GlobalFun from '@/global/global-function'
	
	export default {
	    /**
	     * @Des 组件名
	     * @Auth
	     * @Date
	     */
	    name: "Organization",
	    /**
	     * @Des 引用组件
	     * @Auth
	     * @Date
	     */
	    components: {
	        // 组织结构树
	        OrgTree,
	        // 组织模块
	        OrgModule,
	    },
	    /**
	     * @Des 数据定义
	     * @Auth
	     * @Date
	     */
	    data(){
	        return {
	            showTreeBoxFlag: true,
	            nodeData: {},
	            nodeLevel: -1,
	            organizations:[]
	        }
	    },
	    created(){
	        // 查询组织结构
	        this.searchOrg();
	    },
	    /**
	     * 方法定义
	     */
	    methods:{
	        /**
	         * @Des 关闭路由
	         * @Auth
	         * @Date
	         */
	        closeRouter () {
	            // 跳转到 首页
	            this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
	        },// closeRouter
	
	        /**
	         * @Des 切换 tree box 状态
	         * @Auth
	         * @Date
	         */
	        toggleTreeBox(val) {
	            this.showTreeBoxFlag = val;
	        },
	
	        /**
	         * @Des 设置选中的值
	         * @Auth
	         * @Date
	         */
	        setSelectVal(data, flushOrg){
	
	            // 数据重置
	            this.resetData();
	
	            if(data){
	                // 级别
	                this.nodeLevel = data.level;
	                // 数据
	                this.nodeData = data;
	            }
	
	            // 刷新节点
	            if(flushOrg){
	                this.searchOrg();
	            }
	
	        },
	        /**
	         * @Des 关闭二级模块
	         * @Auth
	         * @Date
	         */
	        closeSecondModule() {
	        	// 新增模块
	        	this.$refs.OrgModule.addNode(false);
	        },
	
	        /**
	         * @Des 数据重置
	         * @Auth
	         * @Date
	         */
	        resetData(){
	            this.ndoeData = {};
	            this.nodeLevel = -1;
	        },
	
	        /**
	         * @Des 添加节点
	         * @Auth
	         * @Date
	         */
	        addNode(){
	            this.nodeLevel = 0;
	        },
	        /**
	         * @Des 查询组织结构
	         * @Auth
	         * @Date
	         */
	        searchOrg() {
	            this.$request.postJsonRequest(ApiOam.Find_Org_Uri, {
	              projectId: this.$store.state.currentProjectId
	            }).then(result => {
	                this.organizations = [];
	                // console.log(result)
	                if(result.code == 0 && result.data && result.data.length > 0){
	                    result.data.forEach((row, index) => {
	                        row.label = row.name;
	                        if(row.level == 1){
	                            row.label += "（" + row.parentNode.appName + "）";
	                        }else if(row.level == 2){
	                            if(row.project.hasArea == 1){
	                                row.label += "（区域）";
	                            }else{
	                                row.label += "（地图）";
	                            }
	                        }else if(row.level == 3){
	                            row.label += "（地图）";
	                        }
	                    })
	                    this.organizations = GlobalFun.dataToTree(Object.assign([], result.data), {
	                        id: 'id',
	                        pid: 'parentId',
	                        children: 'children',
	                        label: 'label',
	                        node: 'node',
	                        parentNode: 'parentNode',
	                        project: 'project',
	                    });
	                    // console.log(Object.assign([], this.organizations));
	                }
	            }).catch(error => {
	                console.error('组织结构加载异常', ApiOam.Find_Org_Uri, error);
	            })
	        },
	        /**
	         * @Des dom 尺寸更改
	         * @Auth
	         * @Date 2021/10/8
	         */
	        elFormResize(data) {
	            // 清除定时器
	            if (!this.$checkEmpty(this.timer_checkDataInt)) {
	                // 清除定时器
	                clearInterval(this.timer_checkDataInt);
	            }
	
	            if (!this.$checkEmpty(this.overview)) {
	                // 延迟执行
	                this.$nextTick(() => {
	                    // 初始化 charts
	                    // this.initCharts();
	                });
	            } else {
	                // 定时器
	                this.timer_checkDataInt = setInterval(() => {
	                    if (!this.$checkEmpty(this.overview)) {
	                        // 清除定时器
	                        clearInterval(this.timer_checkDataInt);
	                        // 延迟执行
	                        this.$nextTick(() => {
	                            // 初始化 charts
	                            // this.initCharts();
	                        });
	                    }
	                }, 200);
	            }
	        },
	    },// methods
	    
	}// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/views/system-manager/map/Organization.vue